const NIF_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";

export const validateNIF = (nif) => {
  if (typeof nif !== "string") {
    return false;
  }

  const value = nif.trim().toUpperCase();
  if (value === "") {
    return true;
  }

  const startsWithLetter = /^[A-Z]/.test(value);
  const endsWithLetter = /[A-Z]$/.test(value);

  if (startsWithLetter) {
    // CIF: letra + 8 dígitos
    return /^[A-Z]\d{8}$/.test(value);
  }

  if (endsWithLetter) {
    // DNI: 7 u 8 dígitos + letra de control
    const match = value.match(/^(\d{7,8})([A-Z])$/);
    if (!match) {
      return false;
    }
    const [, number, letter] = match;
    return NIF_LETTERS[parseInt(number, 10) % 23] === letter;
  }

  return false;
};
